import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core';
import { Document, Page, pdfjs } from 'react-pdf';
import { useTranslation } from 'react-i18next';

import Button from '../../inputs/Button';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const styles = theme => ({
  dialogPaper: {
    borderRadius: 0,
  },
  document: {
    fontSize: '2.5rem',
  },
});

const fetchPdfFromFirebase = async pdfUrl => {
  const response = await fetch(pdfUrl);
  console.log('response:', response);
  const blob = await response.blob();
  return URL.createObjectURL(blob);
};

function ViewPdfContentModal({ downloadUrl, classes }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [pdfData, setPdfData] = React.useState(null);
  const [numPages, setNumPages] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const { t } = useTranslation();

  const openModal = async () => {
    setIsOpen(true);
    const pdfUrl = await fetchPdfFromFirebase(downloadUrl);
    setPdfData(pdfUrl);
  };

  const closeModal = () => {
    setIsOpen(false);
    setPdfData(null);
    setNumPages(null);
    setCurrentPage(1);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div>
      <Button
        style={{
          width: '100%',
          marginTop: '1rem',
          padding: '0.7rem 1rem 0.5rem',
        }}
        size="md"
        variant="contained"
        color="primary"
        onClick={openModal}
      >
        {t('Description')}
      </Button>
      <Dialog
        open={isOpen}
        aria-labelledby="View PDF content modal"
        onClose={closeModal}
        maxWidth="md"
        fullWidth={true}
      >
        {pdfData && (
          <Document file={pdfData} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page key={index} pageNumber={index + 1} scale="1.5" />
            ))}
          </Document>
        )}
      </Dialog>
    </div>
  );
}

export default withStyles(styles)(ViewPdfContentModal);
